import api from "lib/api/api";

export const FETCH_ADMIN_COURSE_TREE_REQUEST =
  "FETCH_ADMIN_COURSE_TREE_REQUEST";
export const FETCH_ADMIN_COURSE_TREE_SUCCESS =
  "FETCH_ADMIN_COURSE_TREE_SUCCESS";
export const FETCH_ADMIN_COURSE_TREE_FAILURE =
  "FETCH_ADMIN_COURSE_TREE_FAILURE";

export const fetchAdminCourseTree = () => async (dispatch) => {
  dispatch({ type: FETCH_ADMIN_COURSE_TREE_REQUEST });
  try {
    const response = await api.get(`/admin/course-tree`);
    dispatch({ type: FETCH_ADMIN_COURSE_TREE_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({
      type: FETCH_ADMIN_COURSE_TREE_FAILURE,
      payload: error.message || "Failed to load course tree",
    });
  }
};
